import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import axios from 'axios';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Button, Card, CardBody, Col, Row, Table, Modal } from 'reactstrap';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import SiteThermaForm from '../components/SiteThermaForm';

class SiteThermaPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isEdit: false,
      siteThermaId: '',
      siteThermaList: [],
      redirect: false,
    };
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      siteThermaId:
        id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getSiteThermaList();
    }
  };

  delete = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      sitekey: this.props.match.params.id,
      locationkey: id,
      requesteduser:
        user.name === null || user.name === '' ? user.email : user.name,
    };

    axios
      .post(
        'https://zoidapi.pseudoscops.com:3005/v1/extapi/therma/remove',
        data,
      )
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Therma location removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ modal: false });
        this.getSiteThermaList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getSiteThermaList = () => {
    const data = {
      sitekey: this.props.match.params.id,
    };

    axios
      .post('https://zoidapi.pseudoscops.com:3005/v1/extapi/therma/site', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        console.log(result.data);
        this.setState({ siteThermaList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getSiteThermaList();
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <Page
        className="SiteThermaPage"
        title="Site Therma"
        breadcrumbs={[
          { name: 'Site', active: false, path: '/site' },
          { name: 'Site Therma', active: true, path: '/site/:id/site-therma' },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="text-right mb-4">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle('ADD', null)}
                  >
                    Add
                  </Button>
                </div>
                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.siteThermaList.length < 1 && (
                      <tr>
                        <td colSpan="3">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new site therma
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.siteThermaList.length > 0 &&
                      this.state.siteThermaList.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button
                                  color="link"
                                  className="theme-button theme-button-primary-light"
                                  onClick={() => this.delete(item.locationkey)}
                                >
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <SiteThermaForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            data={this.state}
            match={this.props.match}
            getSiteThermaList={this.getSiteThermaList}
          />
        </Modal>
      </Page>
    );
  }
}
export default SiteThermaPage;
